import cloudbase from '@cloudbase/js-sdk'

const app = cloudbase.init({
  env: import.meta.env.VITE_TCB_ENV || 'begingroup-1g6s82e205f983c0',
})

export const auth = app.auth()
export default app
